import React from "react";
import { Paper, Divider, Card } from "@mui/material";

const AlumniMeet = () => {
  return (
    <>
      <div className="my-2">
        <Paper elevation={3}>
          {/* <div className='p-5'> */}

          <div
            style={{
              backgroundImage: "url('assets/campus/alumni.webp')",
              height: "60vh",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            <div className="text-center ">
              <h2 className="about-header"> Alumni </h2>
            </div>
          </div>
          <div className="p-4">
            <div className="row justify-content-center">
              <div className="col-10 col-md-10 d-flex align-items-center">
                {/* <img src="assets/campus/alumni.jpg" alt="affi" className='col-12' /> */}
              </div>
            </div>
          </div>

          {/* </div> */}
        </Paper>
      </div>
    </>
  );
};

export default AlumniMeet;
